<template>
  <div class="coderpix_tm_modalbox" :class="open ? 'opened' : ''">
    <div class="box_inner">
      <div class="close">
        <a href="#" @click="close"><i class="icon-cancel"></i></a>
      </div>
      <div class="description_wrap">
        <div class="about_popup_details">
          <div class="left">
            <div class="left_inner">
              <div class="author">
                <div class="avatar_image">
                  <img src="img/thumbs/1-1.jpg" alt="" />
                  <div class="main" data-img-url="img/about/1.jpg"></div>
                </div>
                <div class="short">
                  <h3 class="name">
                    {{ aboutData.firstName }}
                    <span class="coloring">{{ aboutData.lastName }}</span>
                  </h3>
                  <h3 class="job">
                    <AnimationText />
                  </h3>
                </div>
              </div>
              <div class="list">
                <ul>
                  <li>
                    <div class="list_inner">
                      <i class="icon-user"></i>
                      <span
                        >{{ aboutData.firstName }}
                        {{ aboutData.lastName }}</span
                      >
                    </div>
                  </li>
                  <li>
                    <div class="list_inner">
                      <i class="icon-calendar"></i>
                      <span>{{ aboutData.bithday }}</span>
                    </div>
                  </li>
                  <li>
                    <div class="list_inner">
                      <i class="icon-location"></i>
                      <span
                        ><a href="#" class="href_location">{{
                          aboutData.address
                        }}</a></span
                      >
                    </div>
                  </li>
                  <li>
                    <div class="list_inner">
                      <i class="icon-phone"></i>
                      <span
                        ><a href="#">{{ aboutData.phn }}</a></span
                      >
                    </div>
                  </li>
                  <li>
                    <div class="list_inner">
                      <i class="icon-mail-1"></i>
                      <span
                        ><a :href="`mailto:${aboutData.email}`">{{
                          aboutData.email
                        }}</a></span
                      >
                    </div>
                  </li>
                </ul>
              </div>
              <div class="coderpix_tm_button full">
                <a href="#contact">İletişime Geç</a>
              </div>
            </div>
          </div>
              <div class="right">
            <div class="right_inner">
              <div class="biography">
                <div class="about_title">
                  <h3>
                    <span>Hakkımda <span class="coloring">Bilgiler</span></span>
                  </h3>
                </div>
                <div class="text">
                  <p>
                    {{ aboutData.biography || `Merhaba! Ben Okan Şahin. Web tasarım, otomasyon çözümleri ve e-ticaret alanlarında uzmanlaşmış bir freelancer olarak çalışıyorum. Modern teknolojileri kullanarak iş süreçlerinizi hızlandırıyor ve dijital varlığınızı güçlendiriyorum.` }}
                  </p>
                </div>
              </div>
              
              <div class="service">
                <div class="about_title">
                  <h3>
                    <span>Sunduğum <span class="coloring">Hizmetler</span></span>
                  </h3>
                </div>
                <div class="list">
                  <ul>
                    <li v-for="(service, i) in aboutData.serviceLists" :key="i">
                      <i class="icon-right-dir"></i>{{ service }}
                    </li>
                  </ul>
                </div>
              </div>

              <div class="prog_skill">
                <div class="about_title">
                  <h3>
                    <span>Teknik <span class="coloring">Yetenekler</span></span>
                  </h3>
                </div>
                <div class="oki_progress">
                  <div
                    class="progress_inner"
                    v-for="(skill, i) in aboutData.skills.programming"
                    :key="i"
                  >
                    <span>
                      <span class="label">{{ skill.name }}</span>
                      <span class="number">{{ skill.value }}%</span>
                    </span>
                    <div class="background">
                      <div class="bar open">
                        <div
                          class="bar_in"
                          :style="{ width: `${skill.value}%` }"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="lang_skill">
                <div class="about_title">
                  <h3>
                    <span>Uzmanlık <span class="coloring">Alanları</span></span>
                  </h3>
                </div>
                <div class="circular_progress_bar">
                  <ul>
                    <li>
                      <div class="list_inner">
                        <div class="myCircle" data-value="0.95" style="--progress: 95%"></div>
                        <div class="title"><span>Web Tasarım</span></div>
                      </div>
                    </li>
                    <li>
                      <div class="list_inner">
                        <div class="myCircle" data-value="0.90" style="--progress: 90%"></div>
                        <div class="title"><span>Otomasyon</span></div>
                      </div>
                    </li>
                    <li>
                      <div class="list_inner">
                        <div class="myCircle" data-value="0.85" style="--progress: 85%"></div>
                        <div class="title"><span>E-Ticaret</span></div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import AnimationText from "../AnimationText.vue";
import sanityClient, { urlFor } from "../../sanity";

export default {
  name: `AboutPopup`,
  components: {
    Swiper,
    SwiperSlide,
    AnimationText,
  },
  data() {
    return {
      open: false,
      profileImage: "img/about/1.jpg",
      aboutData: {
        firstName: "Okan",
        lastName: "Şahin",
        bithday: "",
        address: "Ankara, TÜRKİYE",
        phn: "",
        email: "coderpix@gmail.com",
        serviceLists: [
          "Web Tasarım & Geliştirme",
          "N8N Otomasyon Çözümleri",
          "E-Ticaret Entegrasyonu",
          "Sosyal Medya Yönetimi",
          "Grafik Tasarım & Kurumsal Kimlik",
        ],
        skills: {
          programming: [
            { name: "WordPress", value: "95" },
            { name: "E-Ticaret", value: "90" },
            { name: "N8N Otomasyon", value: "85" },
          ],
          language: [
            { name: "Türkçe", value: "100" },
            { name: "İngilizce", value: "70" },
          ],
        },
        education: [],
        working: [
          {
            year: "2020 - devam",
            company: "Freelancer",
            deg: "Web Tasarım & Otomasyon",
          },
        ],
        partnersLogos: [],
        biography: "" 
      },
    };
  },
  methods: {
    close() {
      this.open = false;
    },
    async fetchAboutData() {
      try {
        const query = `*[_type == "siteSettings"][0]`;
        const settings = await sanityClient.fetch(query);
        
        if (settings) {
          if (settings.profileImage) {
            // Otomatik boyutlandırma: 800x800
            this.profileImage = urlFor(settings.profileImage).width(800).height(800).url();
          }
          if (settings.heroTitle) {
            const parts = settings.heroTitle.split(' ');
            this.aboutData.firstName = parts[0] || "Okan";
            this.aboutData.lastName = parts.slice(1).join(' ') || "Şahin";
          }
        }
        
        const aboutQuery = `*[_type == "about"][0]`;
        const about = await sanityClient.fetch(aboutQuery);
        if (about) {
           if (about.description) this.aboutData.biography = about.description;
        }

      } catch (error) {
        console.error("About fetch error:", error);
      }
    }
  },
  mounted() {
    this.fetchAboutData();

    const aboutPopup = document.getElementById("aboutPopup");
    aboutPopup.addEventListener("click", () => {
      this.open = true;
    });

    const myCircle = document.querySelectorAll(".myCircle");
    myCircle.forEach((circle) => {
      let progress = circle.getAttribute("data-value");
      let span = document.createElement("span");
      span.className = "number";
      const value = `${progress * 100}%`;
      span.innerHTML = value;
      circle.appendChild(span);
      circle.style.setProperty("--progress", value);
      circle.setAttribute("aria-valuenow", value);
    });
  },
  updated() {
    // Görseli güncelle
    const mainDiv = document.querySelector('.about_popup_details .left .main');
    if (mainDiv) {
      mainDiv.style.backgroundImage = `url(${this.profileImage})`;
    }
  },
  setup() {
    return {
      modules: [Navigation, Pagination],
    };
  },
};
</script>


<style scoped>
.testimonial {
  overflow: hidden;
}
.owl-carousel.swiper {
  overflow: unset;
}

.myCircle {
  --hue: 220;
  --holesize: 67%;
  --track-bg: hsl(233, 34%, 92%);

  min-width: 110px;
  min-height: 110px;
  display: grid;
  align-items: center;
  justify-items: center;
  place-items: center;
  position: relative;
  margin-bottom: 5px;
}
.myCircle::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 50%;
  z-index: -1;
  background: conic-gradient(
    var(--main-color) var(--progress, 0%),
    rgba(255, 255, 255, 0.15) var(--progress, 0%) 100%
  );

  mask-image: radial-gradient(
    transparent var(--holesize),
    black calc(var(--holesize) + 1px)
  );
}
</style>

